export default __webpack_public_path__ + "static/media/default.f7f43ddd.png";